import axios from 'axios'

export const MusicsService = {
    loadMusics: () => {
        return new Promise(
            function (resolve, reject) {
                axios.get('/musics')
                    .then((response) => {
                        if (response.status === 200) {
                            resolve(response.data)
                        } else {
                            reject(new Error('http status code other than 200: ' + response.status))
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                        reject(error)
                    })
            })
    },
    createMusic: (payload) => {
        return new Promise(
            function (resolve, reject) {
                axios.post('/musics', payload)
                    .then((response) => {
                        if (response.status === 201) {
                            resolve(response.data)
                        } else {
                            reject(new Error('http status code other than 200: ' + response.status))
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                        reject(error)
                    })
            }
        )
    },
    saveMusic: (payload) => {
        return new Promise(
            function (resolve, reject) {
                axios.put('/musics/' + payload.id, payload)
                    .then((response) => {
                        if (response.status === 200) {
                            resolve(response.data)
                        } else {
                            reject(new Error('http status code other than 200: ' + response.status))
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                        reject(error)
                    })
            }
        )
    },
    deleteMusic: (id) => {
        return new Promise(
            function (resolve, reject) {
                axios.delete('/musics/' + id)
                    .then((response) => {
                        if (response.status === 200) {
                            resolve(response.data)
                        } else {
                            reject(new Error('http status code other than 204: ' + response.status))
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                        reject(error)
                    })
            })
    }
}



// WEBPACK FOOTER //
// ./src/services/musics-service.js